// external imports
import { createFragmentContainer, graphql } from 'react-relay'

const ProductUrl = ({ product, children }) => {
    // the url to redirect to
    const categoryUrl = product.category.family
        ? `${product.category.family.name}/${product.category.name}`
        : product.category.name

    return children(`/products/${categoryUrl}/${product.name}`)
}

export default createFragmentContainer(
    ProductUrl,
    graphql`
        fragment ProductUrl_product on Product {
            name
            category {
                name
                family {
                    name
                }
            }
        }
    `
)



// WEBPACK FOOTER //
// ./src/components/ProductUrl.js